import React from 'react';
import { IIcon } from '../../@types/icons';

export function CloseCircleDark ({ onClick }: IIcon) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      onClick={onClick}
    >
      <circle cx="8" cy="8" r="8" fill="#717171" />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.375 5.375l5.25 5.25M10.625 5.375l-5.25 5.25"
      />
    </svg>
  );
}
